import React, { FC, useEffect } from "react";
import { GraphAPIURL, TaskmgmtServiceURL } from "../config/config";
import { ServiceName } from "../constants";
import { useAppDispatch } from "../redux/hooks";
import userContextSlice, {
  UserContext,
  updateUserContext,
} from "../redux/slices/userContextSlice";
import { getApiCall, getUserContextFromAzure } from "./apiHelper";

var currentUserContext: UserContext = {
  accessToken: "",
  tenentId: "",
  email: "",
  displayName: "",
  firstName: "",
  lastName: "",
  usertype: "",
  fundId: "",
  FundName: "",
  isExternal: false,
  isAppraisal1: false,
  isAppraisal2: false,
  isAppraisal3: false,
  isFiduciary: false,
  isDebtAppraisal1: false,
  isDebtAppraisal2: false,
  isDebtAppraisal3: false,
  isDebtFiduciary: false,
  isAccounting: false,
  isAudit: false,
  isAssetManagement: false,
  isAdmin: false,
  appraiser1: undefined,
  appraiser2: undefined,
  appraiser3: undefined,
  fiduciary: undefined,
  debtAppraiser1: undefined,
  debtAppraiser2: undefined,
  debtAppraiser3: undefined,
  debtFiduciary: undefined,
  accounting: undefined,
  admin: undefined,
  audit: undefined,
  assetManagement: undefined,
  firm: "",
  taskManagementToken: undefined,
  investmentToken: undefined,
  lookupToken: undefined,
  documentToken: undefined,
  appraisalToken: undefined,
  logginToken: undefined,
  isEMEA: undefined,
  isAPAC: undefined,
  isUS: undefined,
  region: undefined,
  allowedFunds: [],
};

export const getProfile = async (getFromServer = false) => {
  // if (getFromServer) {
  //   return getUserContextFromAzure(GraphAPIURL).then((user: any) => {
  //     currentUserContext = <UserContext>{};
  //     currentUserContext.isExternal = user.userType === "Member" ? false : true;
  //     currentUserContext.email = (
  //       (!currentUserContext.isExternal
  //         ? user.userPrincipalName
  //         : user.mail) as string
  //     ).toLowerCase();
  //     currentUserContext.displayName = user.displayName;
  //     currentUserContext.firstName = user.givenName;
  //     currentUserContext.lastName = user.surname;
  //     currentUserContext.usertype = user.userType;

  //     const reqUrl = `${
  //       TaskmgmtServiceURL + "/userrolemaps/getall"
  //       }?$filter=(tolower(trim(email)) eq (tolower(trim('${
  //       currentUserContext.email
  //       }')))) and (status eq 'Active')`;
  //     var taskCall = getApiCall(reqUrl, ServiceName.TASKMANAGEMENTSERVICE);
  //     return taskCall.then(
  //       (userRoleData: any) => {
  //         if (userRoleData.result) {
  //           if (userRoleData.result.length > 0) {
  //             currentUserContext = {
  //               ...currentUserContext, fundId: userRoleData.result[0].fundId
  //             }
  //             //currentUserContext.fundId =  userRoleData.result[0].fundId;
  //             currentUserContext.FundName = userRoleData.result[0].fundName;
  //             currentUserContext.firm = userRoleData.result[0].Firm;
  //             currentUserContext.region = userRoleData.result[0].region;
  //             currentUserContext.appraiser1 = userRoleData.result.filter(
  //               (data: any) => data.role === "Equity Appraiser 1"
  //             );
  //             currentUserContext.isAppraisal1 =
  //               currentUserContext.appraiser1.length > 0 ? true : false;
  //             currentUserContext.isEMEA = currentUserContext.region ?.includes(
  //               "EMEA"
  //             )
  //               ? true
  //               : false;
  //             currentUserContext.isUS = currentUserContext.region ?.includes(
  //               "US"
  //             )
  //               ? true
  //               : false;
  //             currentUserContext.isAPAC = currentUserContext.region ?.includes(
  //               "APAC"
  //             )
  //               ? true
  //               : false;
  //             currentUserContext.appraiser2 = userRoleData.result.filter(
  //               (data: any) => data.role === "Equity Appraiser 2"
  //             );
  //             currentUserContext.isAppraisal2 =
  //               currentUserContext.appraiser2.length > 0 ? true : false;
  //             currentUserContext.appraiser3 = userRoleData.result.filter(
  //               (data: any) => data.role === "Equity Appraiser 3"
  //             );
  //             currentUserContext.isAppraisal3 =
  //               currentUserContext.appraiser3.length > 0 ? true : false;
  //             currentUserContext.fiduciary = userRoleData.result.filter(
  //               (data: any) => data.role === "Equity Fiduciary"
  //             );
  //             currentUserContext.isFiduciary =
  //               currentUserContext.fiduciary.length > 0 ? true : false;
  //             currentUserContext.debtAppraiser1 = userRoleData.result.filter(
  //               (data: any) => data.role === "Debt Appraiser 1"
  //             );
  //             currentUserContext.isDebtAppraisal1 =
  //               currentUserContext.debtAppraiser1.length > 0 ? true : false;
  //             currentUserContext.debtAppraiser2 = userRoleData.result.filter(
  //               (data: any) => data.role === "Debt Appraiser 2"
  //             );
  //             currentUserContext.isDebtAppraisal2 =
  //               currentUserContext.debtAppraiser2.length > 0 ? true : false;
  //             currentUserContext.debtAppraiser3 = userRoleData.result.filter(
  //               (data: any) => data.role === "Debt Appraiser 3"
  //             );
  //             currentUserContext.isDebtAppraisal3 =
  //               currentUserContext.debtAppraiser3.length > 0 ? true : false;
  //             currentUserContext.debtFiduciary = userRoleData.result.filter(
  //               (data: any) => data.role === "Debt Fiduciary"
  //             );
  //             currentUserContext.isDebtFiduciary =
  //               currentUserContext.debtFiduciary.length > 0 ? true : false;
  //             currentUserContext.accounting = userRoleData.result.filter(
  //               (data: any) => data.role === "Accounting"
  //             );
  //             currentUserContext.isAccounting =
  //               currentUserContext.accounting.length > 0 ? true : false;
  //             currentUserContext.admin = userRoleData.result.filter(
  //               (data: any) => data.role === "Admin"
  //             );
  //             currentUserContext.isAdmin =
  //               currentUserContext.admin.length > 0 ? true : false;
  //             currentUserContext.audit = userRoleData.result.filter(
  //               (data: any) => data.role === "Audit"
  //             );
  //             currentUserContext.isAudit =
  //               currentUserContext.audit.length > 0 ? true : false;
  //             currentUserContext.assetManagement = userRoleData.result.filter(
  //               (data: any) => data.role === "Asset Management"
  //             );
  //             currentUserContext.isAssetManagement =
  //               currentUserContext.assetManagement.length > 0 ? true : false;
  //             currentUserContext.allowedFunds = [];
  //             userRoleData?.result.forEach((role: any) => {
  //               currentUserContext.allowedFunds.push({
  //                 fundId: role.fundId,
  //                 fundName: role.fundName,
  //               });
  //             });
  //           }
  //         }

  //         localStorage.setItem(
  //           "AppraisalUserContext",
  //           JSON.stringify(currentUserContext)
  //         );
  //         return currentUserContext;
  //       },
  //       (error) => {
  //         if (error.status == 401) {
  //           console.log(error);
  //         }
  //       }
  //     );
  //   });
  // } else {
  //   var context = localStorage.getItem("AppraisalUserContext");
  //   currentUserContext = JSON.parse(context != null ? context : "");
  //   return currentUserContext;
  // }
};
